import React, { useEffect } from "react";
import { bffAuthService } from "../../../services/BffAuthService";
import { useFileQuery } from "../../../app/apiHooks";

/**
 * FileInfoManager - 使用 BFF 认证管理文件信息
 * 
 * 标准做法说明：
 * 1. 使用 bffAuthService 获取认证状态
 * 2. 在认证状态变化时触发文件信息获取
 * 3. 使用 TanStack Query 自动处理数据获取
 */
const FileInfoManager: React.FC = () => {
  const isAuthenticated = bffAuthService.isAuthenticated;
  const { data: fileData, isLoading, error, refetch } = useFileQuery();

  console.log('=== FileInfoManager 初始化 ===');
  console.log('🔐 认证状态:', isAuthenticated);

  // 使用TanStack Query自动处理文件信息获取
  useEffect(() => {
    console.log('🔄 FileInfoManager useEffect 触发');
    console.log('📊 当前认证状态:', isAuthenticated);

    if (isAuthenticated) {
      console.log('✅ 用户已认证，使用TanStack Query获取文件信息');

      // TanStack Query会自动处理数据获取
      if (!isLoading && !fileData && !error) {
        console.log('🔄 触发文件信息重新获取');
        refetch();
      }
    } else {
      console.log('⏳ 用户未认证，等待认证状态');
    }
  }, [isAuthenticated, isLoading, fileData, error, refetch]);

  // 这个组件不渲染任何UI，只负责文件信息管理
  return null;
};

export default FileInfoManager;
